var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status",class:[_vm.statusClass]},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t(`REPAIRS.REPAIR_STATUS_${_vm.status}`))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }